
import { useState } from 'react';

export const useOrderFormState = () => {
  const [quantity, setQuantity] = useState(1);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [customerRegion, setCustomerRegion] = useState('');
  const [customerMunicipality, setCustomerMunicipality] = useState('');
  const [note, setNote] = useState('');

  const resetForm = () => {
    setQuantity(1);
    setCustomerName('');
    setCustomerPhone('');
    setCustomerEmail('');
    setCustomerAddress('');
    setCustomerRegion('');
    setCustomerMunicipality('');
    setNote('');
  };

  return {
    formData: {
      quantity,
      customerName,
      customerPhone,
      customerEmail,
      customerAddress,
      customerRegion,
      customerMunicipality,
      note,
    },
    setters: {
      setQuantity,
      setCustomerName,
      setCustomerPhone,
      setCustomerEmail,
      setCustomerAddress,
      setCustomerRegion,
      setCustomerMunicipality,
      setNote,
    },
    resetForm
  };
};
